<template>
  <div class="premission_index">
    <!-- 编辑弹框 -->
    <div><h2 class="tan_header">基本资料</h2></div>
    <el-form :model="formEdit" :rules="rules" :inline="true" ref="formEdit">
      <!-- <el-form-item prop="content" label="公告内容:" :label-width="formLabelWidth">
          <el-input type="textarea" :row="3" placeholder="请输入公告内容" v-model="formEdit.content" autocomplete="off"></el-input>
        </el-form-item> -->
        
      <el-form-item
        prop="name"
        label="医院名称:"
        :label-width="formLabelWidth"
      >
        <el-input
          placeholder="请输入医院名称"
          v-model="formEdit.name"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        prop="phone"
        label="联系电话:"
        :label-width="formLabelWidth"
      >
        <el-input
          placeholder="请输入联系电话"
          v-model="formEdit.phone"
          autocomplete="off"
        ></el-input>
      </el-form-item>
         <el-form-item
        prop="workTime"
        label="工作时间:"
        :label-width="formLabelWidth"
      >
        <el-input
          placeholder="请输入工作时间"
          v-model="formEdit.workTime"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <!-- <div v-text="formEdit.selected2"></div> -->
      <el-form-item
        prop="area_code"
        label="地区:"
        class="area_box"
        :label-width="formLabelWidth"
      >
        <area-cascader
          type="text"
          :level="1"
          v-model="selected2"
          :data="pcaa"
        ></area-cascader>
      </el-form-item>
      <el-form-item
        prop="street"
        label="详细地址:"
        :label-width="formLabelWidth"
      >
        <el-input
          width="200"
          placeholder="请输入详细地址"
          v-model="formEdit.street"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button @click="dialogFormVisibleEdit = false">取 消</el-button> -->
      <button class="login_Edit" @click="cancelClick">取消</button>
      <!-- <el-button type="primary" @click="postFormEdit">确 定</el-button> -->
      <button @click="postFormEdit" class="ok_Edit">确定</button>
    </div>
  </div>
</template>

<script>
import { AreaCascader } from "vue-area-linkage";
import pinyin from 'js-pinyin'
import { pca, pcaa } from "area-data";
// import { addAnnounce, deleteAnnounce, editAnnounce, announceList } from '@/api/shop.js'

export default {
  name: "Premission",
  data() {
    return {
      portraitNumber:"",
      equipmentList:[],
      studyNoone:"",
      options: [
        {
          value: "内科",
          label: "内科",
          children: [
            {
              value: "呼吸内科",
              label: "呼吸内科",
            },
            {
              value: "消化内科",
              label: "消化内科",
            },
            {
              value: "神经内科",
              label: "神经内科",
            },
            {
              value: "心血管内科",
              label: "心血管内科",
            },
            {
              value: "肾内科",
              label: "肾内科",
            },
            {
              value: "血液内科",
              label: "血液内科",
            },
            {
              value: "免疫科",
              label: "免疫科",
            },
            {
              value: "内分泌科",
              label: "内分泌科",
            },
          ],
        },
        {
          value: "外科",
          label: "外科",
          children: [
            {
              value: "普通外科",
              label: "普通外科",
            },
            {
              value: "神经外科",
              label: "神经外科",
            },
            {
              value: "心胸外科",
              label: "心胸外科",
            },
            {
              value: "泌尿外科",
              label: "泌尿外科",
            },
            {
              value: "心血管外科",
              label: "心血管外科",
            },
            {
              value: "乳腺外科",
              label: "乳腺外科",
            },
            {
              value: "肝胆外科",
              label: "肝胆外科",
            },
            {
              value: "器官移植",
              label: "器官移植",
            },
            {
              value: "肛肠外科",
              label: "肛肠外科",
            },
            {
              value: "烧伤科",
              label: "烧伤科",
            },
            {
              value: "骨外科",
              label: "骨外科",
            },
          ],
        },
        {
          value: "妇产科",
          label: "妇产科",
          children: [
            {
              value: "妇科",
              label: "妇科",
            },
            {
              value: "产科",
              label: "产科",
            },
            {
              value: "计划生育",
              label: "计划生育",
            },
            {
              value: "妇幼保健",
              label: "妇幼保健",
            },
          ],
        },
        {
          value: "儿科",
          label: "儿科",
          children: [
            {
              value: "儿科综合",
              label: "儿科综合",
            },
            {
              value: "小儿内科",
              label: "小儿内科",
            },
            {
              value: "小儿外科",
              label: "小儿外科",
            },
            {
              value: "新生儿科",
              label: "新生儿科",
            },
            {
              value: "儿童营养保健科",
              label: "儿童营养保健科",
            },
          ],
        },
        {
          value: "五官科",
          label: "五官科",
          children: [
            {
              value: "耳鼻喉科",
              label: "耳鼻喉科",
            },
            {
              value: "眼科",
              label: "眼科",
            },
            {
              value: "口腔科",
              label: "口腔科",
            },
          ],
        },
        {
          value: "肿瘤科",
          label: "肿瘤科",
          children: [
            {
              value: "肿瘤内科",
              label: "肿瘤内科",
            },
            {
              value: "肿瘤外科",
              label: "肿瘤外科",
            },
            {
              value: "肿瘤妇科",
              label: "肿瘤妇科",
            },
            {
              value: "骨肿瘤科",
              label: "骨肿瘤科",
            },
            {
              value: "放疗科",
              label: "放疗科",
            },
            {
              value: "肿瘤康复科",
              label: "肿瘤康复科",
            },
            {
              value: "肿瘤综合科",
              label: "肿瘤综合科",
            },
          ],
        },
        {
          value: "皮肤性病科",
          label: "皮肤性病科",
          children: [
            {
              value: "皮肤科",
              label: "皮肤科",
            },
            {
              value: "性病科",
              label: "性病科",
            },
          ],
        },
        {
          value: "中医科",
          label: "中医科",
          children: [
            {
              value: "中医全科",
              label: "中医全科",
            },
            {
              value: "中医内科",
              label: "中医内科",
            },
            {
              value: "中医外科",
              label: "中医外科",
            },
            {
              value: "中医妇科",
              label: "中医妇科",
            },
            {
              value: "中医儿科",
              label: "中医儿科",
            },
            {
              value: "中医保健科",
              label: "中医保健科",
            },
            {
              value: "针灸按摩科",
              label: "针灸按摩科",
            },
            {
              value: "中医骨伤科",
              label: "中医骨伤科",
            },
            {
              value: "中医肿瘤科",
              label: "中医肿瘤科",
            },
          ],
        },
        {
          value: "传染科",
          label: "传染科",
          children: [
            {
              value: "肝病科",
              label: "肝病科",
            },
            {
              value: "艾滋病科",
              label: "艾滋病科",
            },
            {
              value: "结核病",
              label: "结核病",
            },
            {
              value: "寄生虫",
              label: "寄生虫",
            },
          ],
        },
        {
          value: "精神心理科",
          label: "精神心理科",
          children: [
            {
              value: "精神科",
              label: "精神科",
            },
            {
              value: "心理咨询科",
              label: "心理咨询科",
            },
          ],
        },
        {
          value: "麻醉医学科",
          label: "麻醉医学科",
          children: [
            {
              value: "麻醉科",
              label: "麻醉科",
            },
            {
              value: "疼痛科",
              label: "疼痛科",
            },
          ],
        },
        {
          value: "医学影像科",
          label: "医学影像科",
          children: [
            {
              value: "核医学科",
              label: "核医学科",
            },
            {
              value: "放射科",
              label: "放射科",
            },
            {
              value: "超声科",
              label: "超声科",
            },
          ],
        },
        {
          value: "其它科室",
          label: "其它科室",
          children: [
            {
              value: "药剂科",
              label: "药剂科",
            },
            {
              value: "护理科",
              label: "护理科",
            },
            {
              value: "体检科",
              label: "体检科",
            },
            {
              value: "检验科",
              label: "检验科",
            },
            {
              value: "急诊科",
              label: "急诊科",
            },
            {
              value: "公共卫生与预防科",
              label: "公共卫生与预防科",
            },
            {
              value: "全科",
              label: "全科",
            },
            {
              value: "设备科",
              label: "设备科",
            },
          ],
        },
      ],
      ids: "",
      examinationSite: [
        { name: "科室1", id: 1 },
        { name: "科室2", id: 2 },
        { name: "科室3", id: 3 },
      ],
      examinationSite: [
        {
          name: "头部",
          id: 1,
          value: "HEAD",
        },
        {
          name: "颈部",
          id: 2,
          value: "NECK",
        },
        {
          name: "胸部",
          id: 3,
          value: "CHEST",
        },
        {
          name: "腹部",
          id: 4,
          value: "ABDOMEN",
        },
        {
          name: "乳腺",
          id: 5,
          value: "BREAST",
        },
        {
          name: "上肢",
          id: 6,
          value: "UPPER EXTREMITIES",
        },
        {
          name: "下肢",
          id: 7,
          value: "LOWER EXTREMITIES",
        },
      ],
      departmentOption: [
      ],
      selected2: "",
      selected: [], //数组对应的就是选中的那个省市区。根据type来确定是省市区汉字的数组还是编码组成的数组。           //selected[0]省。selected[1]市。selected[2]区。
      pca: pca,
      pcaa: pcaa,
      area_code_array: "",
      regisactive: "未登记",
      regis_id: "0",
      hospitallist: "",
      hospitalId: "",
      modality: "",
      listlist: "",
      keysEdit: [],
      tableDatas: [],
      studyNo: "",
      menuList: "",
      propd: {
        multiple: true,
        label: "name",
        value: "id",
      },
      propss: {
        multiple: true,
        children: "children",
        checkStrictly: true,
        label: "name",
        value: "name",
      },
      isAllSelect: false,
      keys: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      pstlist: "",
      permissionOptions: [],
      checkList: "",
      username: "",
      totalPage: 0,
      currentPage: 1,
      tableData: [],
      dialogFormVisible: false,
      dialogFormVisibleEdit: false,
      formLabelWidth: "",
      list: "",
      formEditlist: [],
      pids: "",
      formEdit: {
       city:'',
       district:'',
       name:'',
       province:'',
       street:'',
       workTime:'',
       phone:'',
      },
      rules: {
        username: [
          { required: true, message: "请输入患者姓名", trigger: "blur" },
        ],
        studyNo: [{ required: true, message: "请输入影像号", trigger: "blur" }],
        // idcard: [
        //   { required: true, message: "请输入身份证号", trigger: "blur" },
        // ],
        // phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        // street: [
        //   { required: true, message: "请输入详细地址", trigger: "blur" },
        // ],
        // studyAge: [{ required: true, message: "请输入患者年龄", trigger: "blur" }],
        gender: [{ required: true, message: "请选择性别", trigger: "blur" }],
        // area_code: [
        //   { required: true, message: "请选择省市区", trigger: "blur" },
        // ],
      },
    };
  },
  created() {
    this.getList();
  },
  watch: {
    list(newVal) {
      this.form.hospitalIds = newVal.join();
      console.log(this.form.hospitalIds);
    },
  },
  beforeRouteLeave(to,from,next){
   to.meta.keepAlive = false
   next(0)
 },
  methods: {
    departmentClick(e){
      console.log(e);
        this.$http
        .get(
          this.GLOBAL.BASE_URL + "v1/devices?token=" +
            sessionStorage.getItem("token"),{
               params: {	
      type: e,
      }
            }
        )
        .then((response) => {
          console.log(response);
          this.equipmentList = response.data.data.list;

        })
        .catch((err) => {
          console.error(err);
        });
    },
    clickId(){
      this.formEdit.studyNo = this.studyNoone;
    },
    cnToEn(cn){
      let pinyin = require("js-pinyin");
      this.formEdit.pinyin = pinyin.getFullChars(cn);
    },
    handleChange(value) {
      console.log(value);
      if (value) {
        this.pids = value.join("/");
        console.log(this.pids);
      }
    },
    cancelClick() {
      this.$router.push({
        path: "/study/record",
      });
    },
    time(time = +new Date()) {
      var date = new Date(time + 8 * 3600 * 1000);
      return date.toJSON().substr(0, 19).replace("T", " ").replace(/-/g, "-");
    },
    getList() {
      this.$http
        .post(
          this.GLOBAL.BASE_URL + "v1/study/getGenerateStudyId?token=" +
            sessionStorage.getItem("token")
        )
        .then((response) => {
          console.log(response);
          this.studyNoone = response.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
        
      
          depot
        .get({
          url: "/v1/devices/types",
          params: {
            token: sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.departmentOption = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postFormEdit() {
    
      console.log(this.selected2);
      this.formEdit.province = this.selected2[0];
      console.log(this.formEdit.province);
      // if (this.formEdit.province == 'undefined') {
      //   this.$message({
      //     message: "请选择地区",
      //     type: "error",
      //   });
      //   return;
      // }
      this.formEdit.city = this.selected2[1];
      this.formEdit.district = this.selected2[2];
        // }
      // }
      console.log(this.formEdit);
      if (this.formEdit.gender == "男") {
        this.formEdit.gender = 0;
      } else if(this.formEdit.gender == "女") {
        this.formEdit.gender = 1;
      }
      this.$refs["formEdit"].validate((valid) => {
        if (valid) {
          depot
            .post({
              url: "/v1/hospital/saveHospital",
              data: this.formEdit,
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                this.$router.push({
                  path: "/hospital",
                });
                return;
              }
              this.$message({
                message: res.msg,
                type: "error",
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
.ok_Edit {
  cursor: pointer;
  width: 120px;
  height: 40px;
  background: #009B43;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  margin-left: 30px;
  color: #fff;
}
.login_Edit {
  cursor: pointer;
  width: 120px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  background: #EEEEEE;
  border-radius: 4px;
  border: none;
  color: #999999;
  margin-top: 0 !important;
}
.borders {
  width: 100%;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 19px;
}
.tan_header {
  margin-left: 0px;
  margin-bottom: 15px;
}
/deep/.area_box .area-select .area-selected-trigger {
  padding: 0px 10px !important;
}
.search_click {
  color:#fff;
  width: 100px;
  height: 40px;
  background: #009b43;
  border: none;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
    border-radius: 3px;
}
.search_click:hover {
  border-radius: 3px;
  background-image: linear-gradient(to right, #0ba360, #3cba92, #30dd8a, #2bb673);
  box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75);
   background-position: 100% 0;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.box_cycle {
  display: inline-flex;
}
.box_regis {
  display: inline-flex;
  margin-bottom: 28px;
}
.box_cycle span:first-child {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: 1px solid #fff;
}
.box_cycle span:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: 1px solid #fff;
}
.premission_index {
  padding: 38px;
  background: #fff;
  margin-top: 10px;
  box-sizing: border-box;
}
.search_div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search_input {
  width: 220px;
}
.premission_table {
  margin-top: 10px;
}
/* .pagination_box {
}
.pagination {
  padding: 0 20px;
  margin-top: 20px;
  text-align: right;
} */
.elAdd {
  margin-bottom: 10px;
}
.cyclestyle {
  cursor: pointer;
  width: 62px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  background: #c4c4c4;
  font-size: 14px;
  opacity: 0.8;
}
.active {
  background: #009b43;
  cursor: pointer;
  color: #fff;
}
.register {
  cursor: pointer;
  width: 139px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  background: #c4c4c4;
  font-size: 14px;
  opacity: 0.8;
}


.registeractive {
  cursor: pointer;
  color: #fff;
  background: #009b43;
}
.statusone {
  color: #ed6f00 !important;
}
/* /deep/.pagination .btn-prev {
  display: none !important;
}
/deep/.pagination .btn-next {
  display: none !important;
}

/deep/.pagination .el-pager li:hover {
  color: #000 !important;
}
/deep/.pagination .el-pager .active {
  background: #009b4 3 !important;
  color: #fff !important;
} */
/deep/ .area_box .area-select {
  width: 100%!important;
  height: 40px!important;
}
/deep/.area_box .area-select .area-selected-trigger {
  display: flex;
  align-items: center;
  color: #bcbcbd !important;
}
/deep/.el-form-item {
  width: 30%!important;
}
/deep/.el-form-item .el-form-item__label {
  width: 90px!important;
}
.widthss {
  width: 100%!important;
}
/deep/.el-form--inline .el-form-item__content {
    width: calc(100% - 100px)!important;
}
/deep/.area-select.large {
    width: 100%!important;
  } 
</style>




// WEBPACK FOOTER //
// src/views/addhospital/index.vue